import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const ParagraphIcon: React.FC<AddIconProps> = ({ size = 22, color = '#0556CB', className, onClick }) => (
  <svg width="48" height="41" viewBox="0 0 48 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="30.209" y="0.705078" width="17.4656" height="3.17228" fill={color} fillOpacity="0.15" />
    <rect x="30.209" y="7.67419" width="17.4656" height="3.17228" fill={color} fillOpacity="0.15" />
    <rect x="30.209" y="14.6433" width="17.4656" height="3.17228" fill={color} fillOpacity="0.15" />
    <rect x="30.209" y="21.6125" width="17.4656" height="3.17228" fill={color} fillOpacity="0.15" />
    <rect y="27.2839" width="47.8281" height="3.17228" fill={color} fillOpacity="0.15" />
    <rect y="32.4083" width="47.8281" height="3.17228" fill={color} fillOpacity="0.15" />
    <rect y="37.5328" width="47.8281" height="3.17228" fill={color} fillOpacity="0.15" />
    <path d="M3.02539 22.7271L6.83689 14.6557M6.83689 14.6557L12.6493 2.34709C12.9556 1.69844 13.8806 1.70451 14.1784 2.35713L19.7897 14.6557M6.83689 14.6557H19.7897M19.7897 14.6557L23.5285 22.7271" stroke={color} stroke-opacity="0.3" stroke-width="3.72815" stroke-linecap="round" />
  </svg>


);

export default ParagraphIcon;
